import React, { Fragment } from "react";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import {
  Col,
  Card,
  CardBody,
  CardTitle,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Row,
} from "reactstrap";
import TablaFlia from "./TableHover";
import TablaActivity from "./ActivityList";
import { ResponsiveContainer, LineChart, Line } from "recharts";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";


import { toast } from "react-toastify";

import Tabs from "react-responsive-tabs";
import TablaAlumnos from "./AlumnosList";
import PageTitle from "../../../../Layout/AppMain/PageTitle";
import privateActions from "../../../../API/privateCalls/privateActions";
import { MINIJUEGOS, HISTORIAS, PLANETAS, NIVELES, CINTURONES } from "../../Alumnos/component/consts_act";
export default class Familia extends React.Component {
  constructor() {
    super();
    this.formRef = React.createRef();
  }

  state = {
    loading: true,
    data: {},
    pageFlia: 0,
    sizeFlia: 7,
    pageAlumnos: 0,
    sizeAlumnos: 10,
    pageActividades: 0,
    sizeActividades: 10,
    listFlia: [],
    listaTabs: [],
    selectedAlumno:{},
    selectedTabKey: 0,
    selectedFlia: {},
    listAlumnos: [],
    selectedActivity: "",
    activityResponse: [],
  };

  componentDidMount() {
    this.loadflia();
  }
  /* 
  Funciona así: Tenes por defecto siempre el Tab de las aulas, haces click en algun aula y se crea un tab nuevo con ese aula que elijiste, 
  Vas a ver todos los alumnos, haces click en algunas de las 5 opciones y se crea un tab mas generico para cualquier de las 5 actividades */

  ////////////////////////////   START  AULAS     \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

  loadflia() {
    privateActions
      .listFamiliasAdmin(
  
        this.state.pageFlia,
        this.state.sizeFlia
      )
      .then((res) => {
        console.log("RES", res);
        this.setState({ listFlia: res, loading: false });
      });
  }

  paginateFlia(direc) {
    if (direc > 0) {
      this.setState({ pageFlia: this.state.pageFlia + 1 }, () => {
        this.loadflia();
      });
    } else {
      this.setState(
        {
          pageFlia:
            this.state.pageFlia == 0
              ? this.state.pageFlia
              : this.state.pageFlia - 1,
        },
        () => {
          this.loadflia();
        }
      );
    }
  }

  handleFlia(flia) {
    this.setState({ selectedFlia: flia });
    this.setState({ loading: true });

    privateActions
      .listAlumnoByFamilia(

        flia.idPublico,
        this.state.pageAlumnos,
        this.state.sizeAlumnos
      )
      .then((res) => {
        this.setState({
          listAlumnos: res,
          loading: false,
          selectedTabKey: 1,
          listaTabs: [
            {
              title: "Usuarios: "+ flia.apellido,
              getContent: () => this.renderAlumnos(),
              index: 1,
            },
          ],
        });
      });
  }

  renderflia() {
    if (this.state.loading) return null;
    return (
      <Fragment>
        <ReactCSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}
        >
          <Row>
            <Col lg="12">
              <Card className="main-card mb-3">
                <CardBody>
                  <CardTitle>Familias</CardTitle>
                  <TablaFlia
                    page={this.state.pageFlia}
                    paginate={(num) => this.paginateFlia(num)}
                    data={this.state.listFlia}
                    onView={(flia) => this.handleFlia(flia)}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </ReactCSSTransitionGroup>
      </Fragment>
    );
  }

  ////////////////////////////   END  AULAS     \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

  ////////////////////////////  START  ALUMNOS     \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

  loadAlumnos() {
    this.setState({ loading: false });
    privateActions
    .listAlumnoByFamilia(

      this.state.selectedFlia.idPublico,
      this.state.pageAlumnos,
      this.state.sizeAlumnos
    )
      .then((res) => {
        this.setState({ listAlumnos: res, loading: false });
      });
  }
  renderAlumnos() {
    if (this.state.loading) return null;

    return (
      <Fragment>
        <ReactCSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}
        >
          <Row>
            <Col lg="12">
              <Card className="main-card mb-3">
                <CardBody>
                  <CardTitle>
                  Usuarios familia: {this.state.selectedFlia.apellido}
                  </CardTitle>
                  <TablaAlumnos
                    openActivity={(e, activity) =>
                      this.openActivity(e, activity)
                    }
                    page={this.state.pageAlumnos}
                    paginate={(num) => this.paginateAlumnos(num)}
                    data={this.state.listAlumnos}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </ReactCSSTransitionGroup>
      </Fragment>
    );
  }

  paginateAlumnos(direc) {
    if (direc > 0) {
      this.setState({ pageAlumnos: this.state.pageAlumnos + 1 }, () => {
        this.loadAlumnos();
      });
    } else {
      this.setState(
        {
          pageAlumnos:
            this.state.pageAlumnos == 0
              ? this.state.pageAlumnos
              : this.state.pageAlumnos - 1,
        },
        () => {
          this.loadAlumnos();
        }
      );
    }
    this.setState({ selectedTabKey: 0 }, () => {
      setTimeout(() => {
        this.setState({ selectedTabKey: 1 });
      }, 100);
    });
  }

  ////////////////////////////  END  ALUMNOS     \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

  

  ////////////////////////////  START  ACTIVITY   \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
  //this.state.selectedActivity == LA ACTIVIDAD ACTIVA
  //this.state.activityResponse == LISTA QUE VIENE DEL BACKEND
  //this.state.selectedAlumno == ALUMNO QUE ELEJAN
  renderActivity() {
    if (this.state.loading) return null;

    return (
      <Fragment>
        <ReactCSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}
        >
          <Row>
            <Col lg="12">
              <Card className="main-card mb-3">
                <CardBody>
                  <CardTitle>{this.state.selectedActivity}</CardTitle>
                  <TablaActivity
                    activity={this.state.selectedActivity}
                    page={this.state.pageActividades}
                    paginate={(num) => this.paginateActivity(num)}
                    data={this.state.activityResponse}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </ReactCSSTransitionGroup>
      </Fragment>
    );
  }

  openActivity = (e, activity) => {
    this.setState({ selectedActivity: activity });
    this.setState({selectedAlumno:e})
    this.setState({ loading: true });

    switch (activity) {
      case CINTURONES:
        privateActions
          .CinturonAsteroideAdminAlumno(
            e.idPublico,
            this.state.pageActividades,
            this.state.sizeActividades
          )
          .then((res) => {
            console.warn("ACTIVITY: ", activity, "RES: ", res);
            let newList = this.state.listaTabs;
            newList.push({
              title: activity + ": " + e.usuario,
              getContent: () => this.renderActivity(),
              index: this.state.listaTabs.length + 1,
            });
            this.setState({
              selectedTabKey: this.state.listaTabs.length,
              loading: false,
              activityResponse: res,
              listaTabs: newList,
            });
          });

        break;

      case NIVELES:
        privateActions
          .PasoDeNivelAdminAlumno(
            e.idPublico,
            this.state.pageActividades,
            this.state.sizeActividades
          )
          .then((res) => {
            console.warn("ACTIVITY: ", activity, "RES: ", res);
            let newList = this.state.listaTabs;
            newList.push({
              title: activity + ": " + e.usuario,
              getContent: () => this.renderActivity(),
              index: this.state.listaTabs.length + 1,
            });
            this.setState({
              selectedTabKey: this.state.listaTabs.length,
              loading: false,
              activityResponse: res,
              listaTabs: newList,
            });
          });

        break;

      case PLANETAS:
        privateActions
          .planetasDesbloqueadosAdminAlumno(
            e.idPublico,
            this.state.pageActividades,
            this.state.sizeActividades
          )
          .then((res) => {
            console.warn("ACTIVITY: ", activity, "RES: ", res);
            let newList = this.state.listaTabs;
            newList.push({
              title: activity + ": " + e.usuario,
              getContent: () => this.renderActivity(),
              index: this.state.listaTabs.length + 1,
            });
            this.setState({
              selectedTabKey: this.state.listaTabs.length,
              loading: false,
              activityResponse: res,
              listaTabs: newList,
            });
          });

        break;

      case HISTORIAS:
        privateActions
          .historiasLeidasAdminAlumnos(
            e.idPublico,
            this.state.pageActividades,
            this.state.sizeActividades
          )
          .then((res) => {
            console.warn("ACTIVITY: ", activity, "RES: ", res);
            let newList = this.state.listaTabs;
            newList.push({
              title: activity + ": " + e.usuario,
              getContent: () => this.renderActivity(),
              index: this.state.listaTabs.length + 1,
            });
            this.setState({
              selectedTabKey: this.state.listaTabs.length,
              loading: false,
              activityResponse: res,
              listaTabs: newList,
            });
          });

        break;

      case MINIJUEGOS:
        privateActions
          .MiniJuegosAdminAlumnos(
            e.idPublico,
            this.state.pageActividades,
            this.state.sizeActividades
          )
          .then((res) => {
            console.warn("ACTIVITY: ", activity, "RES: ", res);
            let newList = this.state.listaTabs;
            newList.push({
              title: activity + ": " + e.usuario,
              getContent: () => this.renderActivity(),
              index: this.state.listaTabs.length + 1,
            });
            this.setState({
              selectedTabKey: this.state.listaTabs.length,
              loading: false,
              activityResponse: res,
              listaTabs: newList,
            });
          });

        break;

      default:
        break;
    }
  };


  loadActivity = () => {

    let e = this.state.selectedAlumno
    let activity = this.state.selectedActivity
    switch (activity) {
      case CINTURONES:
        privateActions
          .GetCinturonAlumno(
            localStorage.getItem("idUsuario"),
            e.idPublico,
            this.state.pageActividades,
            this.state.sizeActividades
          )
          .then((res) => {           
            this.setState({
              selectedTabKey: this.state.listaTabs.length,
              loading: false,
              activityResponse: res,
           
            });
          });

        break;

      case NIVELES:
        privateActions
          .GetPasoNivelAlumno(
            localStorage.getItem("idUsuario"),
            e.idPublico,
            this.state.pageActividades,
            this.state.sizeActividades
          )
          .then((res) => {
            console.warn("ACTIVITY: ", activity, "RES: ", res);
   
            this.setState({
              selectedTabKey: this.state.listaTabs.length,
              loading: false,
              activityResponse: res,
        
            });
          });

        break;

      case PLANETAS:
        privateActions
          .GetPlanetasAlumno(
            localStorage.getItem("idUsuario"),
            e.idPublico,
            this.state.pageActividades,
            this.state.sizeActividades
          )
          .then((res) => {
            console.warn("ACTIVITY: ", activity, "RES: ", res);
       
            this.setState({
              selectedTabKey: this.state.listaTabs.length,
              loading: false,
              activityResponse: res,
              
            });
          });

        break;

      case HISTORIAS:
        privateActions
          .GetHistoriasAlumno(
            localStorage.getItem("idUsuario"),
            e.idPublico,
            this.state.pageActividades,
            this.state.sizeActividades
          )
          .then((res) => {
            console.warn("ACTIVITY: ", activity, "RES: ", res);

            this.setState({
              selectedTabKey: this.state.listaTabs.length,
              loading: false,
              activityResponse: res,
              
            });
          });

        break;

      case MINIJUEGOS:
        privateActions
          .GetMiniJuegoAlumno(
            localStorage.getItem("idUsuario"),
            e.idPublico,
            this.state.pageActividades,
            this.state.sizeActividades
          )
          .then((res) => {
            console.warn("ACTIVITY: ", activity, "RES: ", res);
 
            this.setState({
              selectedTabKey: this.state.listaTabs.length,
              loading: false,
              activityResponse: res,
              
            });
          });

        break;

      default:
        break;
    }
  };



  paginateActivity(direc) {
    if (direc > 0) {
      this.setState({ pageActividades: this.state.pageActividades + 1 }, () => {
        this.loadActivity()
      });
    } else {
      this.setState(
        {
          pageActividades:
            this.state.pageActividades == 0
              ? this.state.pageActividades
              : this.state.pageActividades - 1,
        },
        () => {
          this.loadActivity()
        }
      );
    }
    this.setState({ selectedTabKey: 1 }, () => {
      setTimeout(() => {
        this.setState({ selectedTabKey: 2 });
      }, 100);
    });
  }

  ////////////////////////////  END  ACTIVITY   \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

  ////////////////////////////  RENDER METHOD \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

  handleChangeTab(res) {
    console.warn(res, this.state.selectedTabKey);
    if (res == 0) {
      this.setState({ selectedTabKey: res, listaTabs: [] });
    }
    if (res == 1 && this.state.selectedTabKey == 2) {
      let list = this.state.listaTabs;
      list.pop();
      this.setState({ selectedTabKey: res, listaTabs: list });
    } else {
      this.setState({ selectedTabKey: res });
    }
  }

  render() {
    return (
      <Fragment>
        <PageTitle
          heading={
            this.state.selectedTabKey == 0
              ? `Familias `
              : this.state.selectedTabKey == 1
              ? `Familia: ${this.state.selectedFlia.apellido}`
              : `Actividades`
          }
          subheading={
            this.state.selectedTabKey == 0
              ? "Un espacio dedicado a que puedas manejar tus aulas"
              : this.state.selectedTabKey == 1
              ? `Detalles de familia: ${this.state.selectedFlia.apellido}`
              : `Actividades`
          }
          icon="lnr-graduation-hat icon-gradient bg-mean-fruit"
        />
        <Tabs
          tabsWrapperClass="body-tabs body-tabs-layout"
          transform={false}
          showInkBar={true}
          selectedTabKey={this.state.selectedTabKey}
          onChange={(res) => this.handleChangeTab(res)}
          uid={this.state.pageAlumnos}
          items={[
            {
              title: "Familias",
              getContent: () => this.renderflia(),
              index: 0,
            },
            ...this.state.listaTabs,
          ]}
        />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// src/Pages/Demografico/Familia/component/Familia.js